import BaseScreen from "./BaseScreen";
import { NavigationService } from "../../navigation/";

import UIDs from "../../UIDs";

class AuthorizedScreen extends BaseScreen {    
    componentDidMount() {
        super.componentDidMount();

        if (!this.isLoggedIn(this.props.userId)) {
            //if not guest, user is logged out case, we redirect to login
            NavigationService.navigateToPageByUID(this, UIDs.screens.account.teacherlogin);
            return;
        }
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (!this.isLoggedIn(prevProps.userId)) {
            setTimeout(() => {
                //if not guest, user is logged out case, we redirect to login
                NavigationService.navigateToPageByUID(this, UIDs.screens.account.teacherlogin);
            }, 0);
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }
}

AuthorizedScreen.propTypes = {
    ...BaseScreen.propTypes
};

export default AuthorizedScreen;